// extracted by mini-css-extract-plugin
module.exports = {"video_container":"FJVideoMedias_video_container__2ohJJ","active":"FJVideoMedias_active__1z8zz"};